<template>
  <div class="animated fadeIn">
    <b-card no-header>
      <b-form>
        <b-form-group
          label="Celular"
          label-for="celular"
          :label-cols="labelCols"
          description="Ingrese el número de celular con código de area sin 0 y sin 15">
          <b-form-input 
            id="celular"
            v-model.trim="$v.celular.$model" 
            :state="celularValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="celularFeedback">
            {{ celularInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label="Mensaje"
          label-for="mensaje"
          :label-cols="labelCols">
          <b-form-input 
            id="mensaje"
            :value="mensaje" 
            readonly
            type="text">
          </b-form-input>
        </b-form-group>
        <!-- {{ mensaje }} -->
      </b-form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="send">Enviar</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="close">Cancelar</b-button>
      </div>
      <b-alert
        class="alert"
        :show="dismissCountDown"
        dismissible
        fade
        :variant="alertVariant"
        @dismissed="dismissCountDown= 0"
        @dismiss-count-down="countDownChanged">
        <p>{{ alertMsj }}</p>
      </b-alert>
    </b-card>
  </div>
</template>

<script>
import { msjAlert } from '../../mixins/msjAlert';
import { required, numeric } from 'vuelidate/lib/validators';


export default {
  name: 'SMS',
  components: {
  },
  mixins: [ 
    msjAlert, 
  ],
  props: {
    mensaje: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      celular: '',

      noValidar: true,
      celularValido: null,
      celularInvalidoMsj: '',

      labelCols: 2
    }
  },
  computed: {
  },  
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
            this.$v.$touch();
          
          this.displayErrores(event.target.id);
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'celular' || validarTodos) {
        if (this.$v.celular.$error) {
          this.celularValido = false;
          if (!this.$v.celular.required) {
            this.celularInvalidoMsj = 'Debe ingresar el número de celular';
          } else if (!this.$v.celular.numeric) {
            this.celularInvalidoMsj = 'El número de celular sólo puede contener dígitos numéricos.';
          } else if (!this.$v.celular.longitudCelular) {
            this.celularInvalidoMsj = 'El número de celular debe tener 10 dígitos numéricos.';
          }
        } else {
          this.celularValido = null;
          this.celularInvalidoMsj = '';
        }
      }
    },
    send () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();

        let params = {
            numero: this.celular,
            mensajeTexto: this.mensaje.trim(),
        }
        
        this.$store.dispatch('evento/sendSMS', params)
          .then(()  => this.showAlert('El mensaje se envió con éxito.', 'info', this.sent))
          .catch(error => this.showAlertError(error))
          .finally(() => this.hideSpinner())
      }
    },
    sent() {
      this.$emit('close', true);
    },
    close() {
      this.$emit('close', false);
    },    
  },
  watch: {
  },
  validations: {
    celular: {
      required,
      numeric,
      longitudCelular: function(value) {
        let numero = value.toString().trim();

        if (numero.length == 10) {
          return true;
        } else {
          return false;
        }
      }
    },
  },  
}
</script>

<style>
</style>
